module.exports = __webpack_public_path__ + "h5/img/value.d09f2783.jpg";